// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U59U","label":"styles_label__2gmwr"};